import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const MdmActivitySearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-right {
    text-align: end;
    margin-top: 16px;

    ${responsive.MOBILE`
      margin-top: 0;
    `}

    .header-right-button {
      ${responsive.MOBILE`
        width: 100%;
      `}
    }
  }
`;
